import type { JSX } from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';

import { LegacyHtml as Html } from 'src/app/shared/components/html';

import { END_OF_TRUNCATION_NOISE } from '../../../../../../../../constants';
import type { PreviewEmailContentUpdateProps } from '../../../../../../types';

export function PreviewEmailContentUpdate({ contentHtml, limit }: PreviewEmailContentUpdateProps): JSX.Element {
	let text = contentHtml;
	let isTruncated = false;
	if (text.length > limit) {
		text = contentHtml.substring(0, limit).replace(END_OF_TRUNCATION_NOISE, '');
		isTruncated = true;
	}

	return (
		<Box px={16} mb={16}>
			<Html
				html={text}
				data-testid="preview-email-update-content"
				sx={{
					...(isTruncated
						? {
								// eslint-disable-next-line @typescript-eslint/naming-convention
								'p:last-of-type:after': { content: "'…'" },
							}
						: {}),
				}}
			></Html>
		</Box>
	);
}
